var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Flags"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66823 16.4665H2.60156V1.84649H3.66823C3.97077 2.19859 4.35392 2.48523 4.78651 2.66505C5.21911 2.84488 5.68895 2.92222 6.15783 2.89078C7.00741 2.83955 7.83264 2.59266 8.56636 2.17022C9.36704 1.78282 10.2424 1.56572 11.1349 1.5332C12.008 1.54124 12.8645 1.76733 13.6234 2.19006L14.3349 2.64955V3.69384V9.96061V11.0091L13.6234 10.5496C12.8649 10.1253 12.0084 9.89737 11.1349 9.88752C10.3627 9.96438 9.61318 10.1875 8.92796 10.5444C8.06273 10.9566 7.11664 11.1807 6.15463 11.2012C5.26056 11.2741 4.37166 11.0112 3.66823 10.4661V16.4613V16.4665ZM4.78757 9.97183C4.3553 9.79196 3.97198 9.51561 3.66823 9.16487V3.25419C4.399 3.73959 5.27792 3.96447 6.15783 3.89121C7.11883 3.87072 8.06389 3.64662 8.92796 3.23435C9.61285 2.87667 10.3626 2.65354 11.1349 2.57749C11.8885 2.5984 12.6237 2.81072 13.2682 3.19362L13.2704 9.32151C12.6022 9.01544 11.8726 8.85097 11.1349 8.84323C10.2422 8.87448 9.36658 9.09164 8.56636 9.48024C7.83276 9.90294 7.00747 10.1498 6.15783 10.2008C5.68909 10.2301 5.21984 10.1517 4.78757 9.97183Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/flags.0f08f413c65e345b77948f5ddf6bc2af.svg";
export { ForwardRef as ReactComponent };